<template lang="pug">
  header.bg-white
    SupportMail(
      :dialogVisible='dialogVisibleSupport'
      @handleParentClose='handleParentClose($event)'
    )
    .p-30(:class='{"py-26": !$route.meta.hideGroupsDropdown}')
      | {{ fnCheckLockDown() }}
      .header-col
        .show-hide
          el-button(@click='setMainMenuCollapse', type='text').outline-none.py-0.text-secondary
            font-awesome-icon(:icon='["fal", isMainMenuCollapsed ? "bars" : "less-than"]').fs-18

          el-button(
            @click='backToDashboard',
            type='text',v-if="$route.meta.showCloseIcon"
          ).outline-none.py-0.text-secondary
            font-awesome-icon(:icon='["fal", "times"]').fs-18

        h4.mb-0.page-title {{ $route.meta.title }}
        .calender-sec(v-if='!$route.meta.hideGroupsDropdown')
          calender-control(v-bind='elMenuStyle' :isDateRange='false')

        .calender-sec(v-if='!$route.meta.hideGroupsDropdown2')
          calender-control(v-bind='elMenuStyle' :isDateRange='true' )

        .user-profile
          div.serch-by-merchant
            i.el-icon-search(v-if='userTypeName === null || userTypeName === ""')
            el-autocomplete(
              v-if='userTypeName === null || userTypeName === ""'
              v-model="selectedMerchant"
              :trigger-on-focus="true"
              placeholder=`Merchant transaction.`,
              :fetch-suggestions="merchantListSuggestion"
              @select = 'changeMerchant'
              @change = 'changeMerchant'
            ).dropdown-select
          div.serch-by-card
            i.el-icon-search(v-if='userTypeName === null || userTypeName === ""')
            el-select(
              filterable
              v-if='userTypeName === null || userTypeName === ""'
              v-model="selectedCard"
              placeholder="Card transaction.",
              @change = 'changeCard'
            ).dropdown-select
              el-option(
                v-for='item in listOfAllCards'
                :key="item.id"
                :label="item.last_four"
                :value="item.id"
              )
          el-select(
            filterable
            v-model="selectedCompanyId"
            placeholder="Select company",
            v-if='userSignedUpCompaniesList.length > 1'
            @change = 'changeCompany'
          ).dropdown-select
            el-option(
              v-for='item in userSignedUpCompaniesList'
              :key="item.id"
              :label="item.companyName"
              :value="item.id"
            )
          el-button.btn-suport(
            type='text',
            circle='circle',
            @click="btnClicked"
            icon='el-icon-service'
          )
          .notification
            el-button.btn-outline(type='text', circle='circle', icon='el-icon-message-solid')
            widget-notifications(:key="new Date().toString()", :refresh='{date:new Date()}')
          .el-menu-in-header
            el-menu(v-bind='elMenuStyle', @select='handleSelectMenu')
              el-submenu(index='2').menu-item-profile
                template(slot='title')
                  .h-100.mr-11
                    user-avatar(:image='me.userPhoto').pin-y-center.size-42
                  div {{ me.firstName }} {{ me.lastName }}
                    .fs-12 {{ userCompanyName }}
                el-menu-item(
                  v-for='(item, index) in me.companies'
                  :key='index'
                  @click='$store.dispatch("users/signInChild", $router)'
                ).px-20
                  i(class='el-icon-setting')
                  span(slot='title') {{ item.companyName }}
                el-menu-item(index='/change-password').px-20
                  i(class='el-icon-setting')
                  span(slot='title') Change Password
                el-menu-item(@click='$store.dispatch("users/signOutMe", $router)').px-20
                  i(class='el-icon-switch-button')
                  span(slot='title') Sign Out
      CreditConnectDialog(
        :dialogVisible='CTAdialogVisible'
        @handleParentClose='CTAhandleClose($event)',
        @handleParentComfirm='CTAhandleParentComfirm($event)',
      )
      resetPasswordDialog(
        :showResetPasswordDialog='showResetPasswordDialog'
        @handlePasswordChange='handlePasswordChange($event)',
      )
      el-dialog(
        :title="this.form.categoryName"
        :visible.sync="dialogVisible"
        ).max-dialog-w-600
          template(v-if="NotificationRequests !== null && SpendNotification !== null")
            .alert.alert-info(v-if="msg")
              div {{ msg }}
            .row.align-items-center.mb-3
              .col-auto
                employee-avatar(
                    :image='NotificationRequests.userPhoto'
                  ).size-100px
              .col.pl-0
                .fs-18 {{ NotificationRequests.userName }}
                .fs-16 {{ NotificationRequests.email }}

            .row.align-items-center
              .col
                .row.mb-3
                  .col-6
                    .fs-16 Date:
                    .fs-18.fw-b {{ getDates( NotificationRequests.requestDate ) }}
                  .col-6
                    .fs-16 Amount:
                    .fs-18.fw-b {{ NotificationRequests.amount | toUSD }}
                .mb-3(v-if='NotificationRequests.note')
                  .fs-16 Note:
                  .fs-18.fw-b {{ NotificationRequests.note }}

            span(slot="footer" class="dialog-footer" v-if='this.budgetCheck === true')
              el-button(
                @click="declineRequest(NotificationRequests.id)"
                v-if='NotificationRequests.reqStatus !== 1 || NotificationRequests.reqStatus !== 2 || NotificationRequests.reqStatus !== 3'
              ) Decline
              el-button(
                type="primary" @click="approveRequest(NotificationRequests.id)"
                v-if='NotificationRequests.reqStatus !== 1 || NotificationRequests.reqStatus !== 2 || NotificationRequests.reqStatus !== 3'
              ) Approve
              el-button(
                @click="cancelRequest(NotificationRequests.id)"
                v-if='NotificationRequests.reqStatus !== 1 || NotificationRequests.reqStatus !== 2 || NotificationRequests.reqStatus !== 3'
              ) Remove
            span(slot="footer" class="dialog-footer" v-else='v-else')
              el-button(
                @click="declineRequest(NotificationRequests.id)"
                v-if='NotificationRequests.reqStatus !== 1 || NotificationRequests.reqStatus !== 2 || NotificationRequests.reqStatus !== 3'
              ) Decline
              el-button(
                @click="cancelRequest(NotificationRequests.id)"
                v-if='NotificationRequests.reqStatus !== 1 || NotificationRequests.reqStatus !== 2 || NotificationRequests.reqStatus !== 3'
              ) Remove
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import CalenderControl from '@/components/CalenderControl.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import WidgetNotifications from '@/components/WidgetNotifications.vue';
import CreditConnectDialog from '@/components/dialogs/CreditConnectDialog.vue';
import CTACommon from '@/mixins/CTACommon';
import userExpensePermission from '@/mixins/userExpensePermission';
import SupportMail from '@/components/dialogs/supportMail.vue';
import resetPasswordDialog from '@/components/dialogs/resetPasswordDialog.vue';
import EmployeeAvatar from '@/components/UserAvatar.vue';


export default {
  name: 'AppHeader',
  components: {
    CalenderControl,
    WidgetNotifications,
    UserAvatar,
    CreditConnectDialog,
    SupportMail,
    resetPasswordDialog,
    EmployeeAvatar,
  },
  mixins: [
    CTACommon,
    userExpensePermission,
  ],
  data() {
    return {
      msg: null,
      showResetPasswordDialog: false,
      selectedMerchant: null,
      selectedCard: null,
      selectedCompanyId: '',
      userSignedUpCompaniesList: [],
      dialogVisibleSupport: false,
      expirationTime: null,
      dialogVisible: false,
      budgetCheck: true,
      elMenuStyle: {
        mode: 'horizontal',
        'background-color': '#fff',
        'text-color': '#393737',
        'active-text-color': '#0e9ecb',
      },
      form: {
        childMerchantid: '',
        merchantid: '',
        id: '',
        expenseId: '',
        qbSyncId: '',
        qbSyncStatus: '',
        categoryId: '',
        first: '',
        last: '',
        userId: '',
        title: 'Transaction Details:',
        userImage: '',
        userName: '',
        email: '',
        amount: '',
        expenseDate: '',
        merchant: '',
        status: '',
        recordStatus: 0,
        description: '',
        notes: '',
        receipt: '',
        card: '',
        isPhysical: false,
        pending: null,
        descriptionFlag: 0,
        groupId: '',
        groupName: '',
        categoryName: '',
        splitTransactions: {
          id: '',
          selectedCompany: '',
          teamId: '',
          categoryId: '',
          month: '',
          year: '',
          expenseDate: '',
          amount: '',
        },
        TransacisonTag: {
          name: '',
          id: '',
        },
        chartData: {
          allocated: 3000,
          available: 2051,
          spent: 0,
        },
      },
    };
  },
  computed: {
    ...mapGetters('cards', ['listOfAllCards', 'merchantList', 'merchantListCompany']),
    ...mapGetters('users', [
      'me',
      'userCompanyId',
      'getMyTeamList',
      'myTeamList',
      'getMyTeamListUser',
      'userAccAccess',
      'userCompanyName',
      'companyDetail',
      'LockDownStatus',
    ]),
    ...mapGetters('managerole', ['userTypeName']),
    ...mapGetters('shared', ['isMainMenuCollapsed']),
    ...mapGetters('notification', ['notificationArray']),
    ...mapGetters('Home', ['UpdateRequest', 'updateBalance', 'isExtConnected', 'NotificationRequests', 'SpendNotification']),
    ...mapGetters('transactions', ['receiptData', 'filterByName']),
  },
  watch: {
    notificationArray() {
      if (this.notificationArray) {
        this.notificationArray.forEach((notification) => {
          if (notification.popupType === 0 && notification.userId !== this.me.id) {
            this.getNotificationWDG(notification);
          }
        });
      }
    },
    filterByName(filterByNameValue) {
      this.selectedMerchant = filterByNameValue;
    },
    $route() {
      const urlPath = this.$route.path;
      if (!urlPath.includes('/transactions/all/team/category')) {
        // clear filter by merchant when navigating away from transaction related screens
        this.filterTransactionsByMerchant('');
      }
      this.$nextTick(this.routeLoaded);
    },

    async me(value) {
      if (value) {
        this.getRoleName({ id: this.me.typeId });
        this.userCompanyListForDropdown();
      }
    },
    async userCompanyId() {
      this.getLsitofCard();
      this.getAllMerchantCompanyWise({ companyId: this.userCompanyId });
      await this.isExtCreditCardConnected({
        companyId: this.userCompanyId,
      });
      this.CTAdialogVisible = this.isExtConnected;
      this.getActiveAccountingSys({
        companyId: this.userCompanyId,
      });
    },
    receiptData(response) {
      if (response) {
        this.getNotifications();
      }
    },
    async UpdateRequest(value) {
      if (value) {
        this.getNotifications();
      }
    },
    async updateBalance(value) {
      if (value) {
        console.log('updateBalance');
      }
    },
    async myTeamList(value) {
      const idArray = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const element of value) {
        idArray.push(element.id);
      }
      this.getTeamUsersAvatar({
        teamId: idArray,
        recordStatus: 1,
        flag: 1,
        companyId: this.userCompanyId,
      });
      await this.getNotifications();
    },
    getMyTeamListUser(value) {
      // eslint-disable-next-line no-restricted-syntax
      for (const element of value) {
        if (element !== null) {
          const indexOf = this.myTeamList.findIndex(team => team.id === element.team.id);
          this.myTeamList[indexOf].users = element.team.users;
        }
      }
    },
  },
  mounted() {
    window.onpopstate = () => {
      if (!localStorage.getItem('token')) {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }
    };
  },
  async created() {
    // localStorage.setItem('pagination', 5);
    // Call fn for resetting password
    this.showPasswordResetDialog();
    this.getAllMerchant({ recordStatus: 1, parent: null });
    if (this.userCompanyId) {
      this.getAllMerchantCompanyWise({ companyId: this.userCompanyId });
    }

    const parentPath = localStorage.getItem('parentPath');
    if (parentPath) {
      // To redirect user to main section of specific section after switching company
      this.$router.push(parentPath);
      localStorage.removeItem('parentPath');
    }
    if (this.userCompanyId) {
      await this.isExtCreditCardConnected({
        companyId: this.userCompanyId,
      });
      this.CTAdialogVisible = this.isExtConnected;
    }

    this.getMe();
    if (this.me.isAllCompanyAdmin) {
      const parent = this.me.Company.filter(item => item.isParent === true);
      this.getUsersWithTeams({
        id: this.me.id, isParentChild: true, companyId: parent[0].id,
      });
    }

    if (!this.me.isAllCompanyAdmin) {
      this.getUsersWithTeams({ id: this.me.id });
    }
    if (this.me) {
      this.userCompanyListForDropdown();
      this.getRoleName({ id: this.me.typeId });
    }
    this.getLsitofCard();
    this.routeLoaded();

    if (this.notificationArray) {
      this.notificationArray.forEach((notification) => {
        if (notification.popupType === 0 && notification.userId !== this.me.id) {
          this.getNotificationWDG(notification);
        }
      });
    }
  },
  methods: {
    ...mapActions('users', ['getMe', 'getUsersWithTeams', 'getTeamUsersAvatar']),
    ...mapActions('accounting', ['getActiveAccountingSys']),
    ...mapActions('shared', ['setMainMenuCollapse']),
    ...mapActions('notification', ['getSubUserExpenses', 'getSubBudgetRequest', 'getNotification', 'getLiveTransactionData', 'notificationArray']),
    ...mapActions('Home', [
      'getNotificationPopup',
      'updateBudgetRequest',
      'notificationSpendAmount',
      'getUpdateBalance',
      'isExtCreditCardConnected',
      'dontShowCreditDialog',
    ]),
    ...mapActions('cards', ['getListOfCard', 'getAllMerchant', 'getAllMerchantCompanyWise']),
    ...mapActions('managerole', ['getRoleName']),
    ...mapActions('transactions', ['filterTransactionsByMerchant']),

    showPasswordResetDialog() {
      // Avoid password reset for masquerade login
      if (localStorage.getItem('isMask') !== 'yes') {
        // if password not null
        if (this.me.lastResetPasswordDate !== null) {
          const lastResetDate = moment(this.me.lastResetPasswordDate);
          const todayDate = moment();
          // find the date differance & show Password reset popup
          const dateDiff = todayDate.diff(lastResetDate, 'month', true);
          // show popup of reset date  is more then 3 yrs old
          if (dateDiff > 3) {
            this.showResetPasswordDialog = true;
          }
        } else {
          this.showResetPasswordDialog = true;
        }
      }
    },

    handlePasswordChange() {
      // close the dialog
      this.showResetPasswordDialog = false;
    },

    getDates(val) {
      if (val) {
        const requestDate = moment(val).format('MM/DD/YYYY');
        const today = moment(new Date()).format('MM/DD/YYYY');
        const yesterday = moment(new Date(Date.now() - 864e5)).format('MM/DD/YYYY');

        if (requestDate === today) {
          return 'Today';
        }
        if (requestDate === yesterday) {
          return 'Yesterday';
        }
      }
      return moment(val).format('MM/DD/YYYY');
    },

    approveRequest(id) {
      this.updateBudgetRequest({ id, reqStatus: 1 });
      this.getNotificationPopup({ id });
      this.dialogVisible = false;
    },
    cancelRequest(id) {
      this.updateBudgetRequest({ id, reqStatus: 3 });
      this.getNotificationPopup({ id });
      this.dialogVisible = false;
    },
    declineRequest(id) {
      this.updateBudgetRequest({ id, reqStatus: 2 });
      this.getNotificationPopup({ id });
      this.dialogVisible = false;
    },

    merchantListSuggestion(merchantQueryString, cb) {
      const merchantList = this.merchantListCompany;
      merchantList.forEach((merchant) => {
        merchant.value = merchant.name;
      });
      let filteredMerchantList = (merchantQueryString) ? merchantList.filter(this.creteFilter(merchantQueryString)) : merchantList;
      filteredMerchantList = filteredMerchantList.sort((firstElement, secondElement) => firstElement.value.localeCompare(secondElement.value));
      // call back function that returns suggestions based on entered value.
      cb(filteredMerchantList);
    },
    creteFilter(merchantQueryString) {
      return merchant => (merchant.value.toLowerCase().indexOf(merchantQueryString.toLowerCase()) === 0);
    },
    changeMerchant() {
      this.filterTransactionsByMerchant(this.selectedMerchant);
      this.$router.push('/transactions/all/team/category', () => {
        // this is intentional
      });
    },
    fnCheckLockDown() {
      if (this.LockDownStatus) {
        this.$router.push('/manage-company/bank-account');
      }
    },

    changeCard() {
      this.$router.push(`/cards/${this.selectedCard}`, () => {
        // this is intentional
      });
    },
    async getLsitofCard() {
      const permission = await this.getAdminRoleArray();
      const teamList = [];
      permission.permissionArray.forEach((element, index) => {
        if (element === 'Admin') {
          teamList.push(permission.IdArray[index]);
        }
      });

      let showAllCard = false;
      if (this.me && this.me.currentCompUserSettings) {
        showAllCard = this.me.currentCompUserSettings[0].showCardList;
      }

      if (this.userAccAccess) {
        showAllCard = this.userAccAccess;
      }

      if (this.userCompanyId) {
        await this.getListOfCard({
          companyId: this.userCompanyId,
          showAllCard,
          userId: this.me.id,
          teamList,
          userAccAccess: this.userAccAccess,
        });
      }
    },

    handleParentClose() { this.dialogVisibleSupport = false; },
    routeLoaded() {
      if (this.me) {
        let timeLeft = 0;
        const expirationTime = localStorage.getItem('expirationTime');
        if (expirationTime) {
          timeLeft = Math.ceil((expirationTime._idleStart + expirationTime._idleTimeout - Date.now()) / 1000);
        }
        if (expirationTime && timeLeft === 0) {
          this.$store.dispatch('users/signOutMe', this.$router);
        } else {
          if (this.expirationTime) {
            clearTimeout(this.expirationTime);
          }
          this.expirationTime = setTimeout(() => { this.$store.dispatch('users/signOutMe', this.$router); }, 3600000);
        }
        localStorage.setItem('expirationTime', this.expirationTime);
      }
    },
    btnClicked() {
      this.dialogVisibleSupport = true;
    },
    handleSelectMenu(key) {
      // available perms: key, keyPath
      if (this.$route.path === key) return;
      this.$router.push(key);
    },

    async getNotifications() {
      const idArray = [];
      const selectArray = [];
      let canArpoveTransactions = false;
      let allPemissionIncresePermission = false;
      await this.myTeamList.forEach((element) => {
        idArray.push(element.id);
      });


      await this.getMyTeamList.forEach((team) => {
        if (team.team.slug === 'all-teams') {
          team.permissions2.forEach((permission) => {
            if (permission.slug === 'approve_transactions') {
              canArpoveTransactions = true;
            }
            if (permission.slug === 'approve_increase_request') {
              allPemissionIncresePermission = true;
            }
          });
        }
      });
      if (!allPemissionIncresePermission) {
        await this.getMyTeamList.forEach((permission) => {
          permission.permissions2.forEach((p) => {
            if (p.slug === 'approve_increase_request') {
              selectArray.push(permission.team.id);
            }
          });
        });
      }
      this.getSubUserExpenses({
        companyId: this.userCompanyId,
        user: canArpoveTransactions ? {} : { id: this.me.id },
      });
      this.getSubBudgetRequest({
        companyId: this.userCompanyId,
        groupId: allPemissionIncresePermission ? idArray : selectArray,
      });
      this.getNotification({
        companyId: this.userCompanyId,
        groupId: allPemissionIncresePermission ? idArray : selectArray,
        user: canArpoveTransactions ? {} : { id: this.me.id },
      });
      // Call for Live transaction  data on Dashboard
      if (this.$router.currentRoute.path === '/') {
        this.getLiveTransactionData({
          companyId: this.userCompanyId,
          user: canArpoveTransactions ? {} : { id: this.me.id },
        });
      }
    },

    fncheckAccountPerm() {
      return this.userAccAccess;
    },
    backToDashboard() {
      this.$router.push('/sadmin-dashboard');
    },
    userCompanyListForDropdown() {
      const companies = this.me.Company;
      const userSettings = this.me.UserSettings;
      this.userSignedUpCompaniesList = [];
      companies.forEach((company) => {
        if (company.status) {
          const userAssociatedCompanies = userSettings.find(setting => setting.companyId === company.id);
          if (userAssociatedCompanies && userAssociatedCompanies.status) {
            this.userSignedUpCompaniesList.push({ id: company.id, companyName: company.companyName });
          }
        }
      });
      if (this.userSignedUpCompaniesList.length > 1) {
        this.selectedCompanyId = localStorage.getItem('currentCompanyId');
      }
    },
    changeCompany() {
      localStorage.setItem('currentCompanyId', this.selectedCompanyId);
      const metaData = this.$router.history.current.meta;
      if (metaData.parentPath) {
        localStorage.setItem('parentPath', metaData.parentPath);
      }
      window.location.reload();
    },
    getNotificationWDG(item) {
      const {
        id, userId, categoryId, groupName, categoryName, month, year,
      } = item;
      this.catId = item.categoryId;
      this.userIds = item.userId;
      this.form.categoryName = `Additional Budget Request for ${groupName} : ${categoryName}`;
      this.form.groupName = groupName;
      const date = new Date();
      this.dialogVisible = true;
      const years = date.getFullYear();
      const months = date.getMonth() + 1;

      if (item.balanceMax > item.catBudget) {
        this.msg = 'Budget is over the category budget';
        this.budgetCheck = false;
      }

      this.getUpdateBalance({
        id: userId,
        categoryId,
        month: months,
        year: years,
      });

      this.getNotificationPopup({ id });
      this.notificationSpendAmount({
        userId,
        categoryId,
        month,
        year,
      });
    },
  },
};
</script>
